import { LanguageLoader } from '../assets/languages/index.js';

const selectedLanguage = localStorage.getItem("language") === null ? 'fa_IR' : localStorage.getItem("language");
const language = LanguageLoader(selectedLanguage);
const utype = localStorage.getItem('utype');

let tenantConfig = [];
try
{
    tenantConfig = require('../cust/'+utype+'/config.js');
}
catch(ex){ console.log('The custom config does not exists.'); }

let CRMURL = tenantConfig.CRMURL || 'https://app.sarvcrm.com';
const host = window.location.host;
const subdomain = host.includes('.') ? host.split('.')[0] : '';
if (subdomain && subdomain === 'tsvision')
{
	CRMURL = 'https://ts3.sarvcrm.com';
}
if(host === 'sarv.pars-e.com')
{
	CRMURL = 'https://pea.sarvcrm.com';
}
if(host === 'hsportal.sarvcrm.com')
{
	CRMURL = 'https://hisense.sarvcrm.com';
}
let development = false;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
{
	CRMURL = 'http://localhost/APP';
	development = true;
}

export const config = {
	'utype': utype,
	'CRM': CRMURL,
	'api': CRMURL+'/API.php',
	'development': development
};

export const tenantURLs = {
	'portal.ofoghdadeha.ir': 'ofoghdadeha',
	'portal.ofoghdadeha.com': 'ofoghdadeha',
	'crm.irrep.com': 'irrep',
	'support.ressis.net': 'ressis',
	'crm.novinchoob.com': 'novinchoob',
	'crm.savco.co.ir': 'savco',
	'crm.oyaz.co': 'oyaz',
	'crm.fanhab.ir': 'fanhab',
	'portal.kishgas.ir': 'kishgas',
	'portal.alvansabet.ir': 'alvansabet',
	'sarv.pars-e.com': 'pea', 
	'hsportal.sarvcrm.com': 'hisense'
};

export const allModules = {
	'Accounts': {
		'title':'ACCOUNTS',
		'icon':'fa fa-users',
		'hidden':'loggedOut',
		'children': [
			{'title':'LIST', 'path':'/list/Accounts', 'icon':'fa fa-minus', 'component':''},
			{'title':'NEW_RECORD', 'path':'/edit/Accounts', 'icon':'fa fa-minus', 'component':''},
		]
	},
	'Cases': {
		'title':'CASES',
		'icon':'fa fa-ticket',
		'hidden':'loggedOut',
		'children': [
			{'title':'LIST', 'path':'/list/Cases', 'icon':'fa fa-minus', 'component':''},
			{'title':'NEW_RECORD', 'path':'/edit/Cases', 'icon':'fa fa-minus', 'component':''},
		]
	},
	'AOS_Contracts': {
		'title':'CONTRACTS',
		'icon':'fa fa-pencil',
		'hidden':'loggedOut',
		'children': [
			{'title':'LIST', 'path':'/list/AOS_Contracts', 'icon':'fa fa-minus', 'component':''},
			{'title':'NEW_RECORD', 'path':'/edit/AOS_Contracts', 'icon':'fa fa-minus', 'component':''},
		]
	},
	'AOS_Invoices': {
		'title':'INVOICES',
		'icon':'fa fa-file-invoice',
		'hidden':'loggedOut',
		'children': [
			{'title':'LIST', 'path':'/list/AOS_Invoices', 'icon':'fa fa-minus', 'component':''},
			{'title':'NEW_RECORD', 'path':'/edit/AOS_Invoices', 'icon':'fa fa-minus', 'component':''},
		]
	},
	'AOS_Quotes': {
		'title':'QUOTES',
		'icon':'fa fa-file-invoice',
		'hidden':'loggedOut',
		'children': [
			{'title':'LIST', 'path':'/list/AOS_Quotes', 'icon':'fa fa-minus', 'component':''},
			{'title':'NEW_RECORD', 'path':'/edit/AOS_Quotes', 'icon':'fa fa-minus', 'component':''},
		]
	},
	'Leads': {
		'title':'LEADS',
		'icon':'fa fa-bullseye',
		'hidden':'loggedOut',
		'children': [
			{'title':'LIST', 'path':'/list/Leads', 'icon':'fa fa-minus', 'component':''},
			{'title':'NEW_RECORD', 'path':'/edit/Leads', 'icon':'fa fa-minus', 'component':''},
		]
	},
	'Payments': {
		'title':'PAYMENTS',
		'icon':'fa fa-wallet',
		'hidden':'loggedOut',
		'children': [
			{'title':'LIST', 'path':'/list/Payments', 'icon':'fa fa-minus', 'component':''},
			{'title':'NEW_RECORD', 'path':'/edit/Payments', 'icon':'fa fa-minus', 'component':''},
		]
	},
	'Opportunities': {
		'title':'OPPORTUNITIES',
		'icon':'fa fa-anchor',
		'hidden':'loggedOut',
		'children': [
			{'title':'LIST', 'path':'/list/Opportunities', 'icon':'fa fa-minus', 'component':''},
			{'title':'NEW_RECORD', 'path':'/edit/Opportunities', 'icon':'fa fa-minus', 'component':''},
		]
	},
	'Work_Orders': {
		'title':'WORK_ORDERS',
		'icon':'fa fa-tools',
		'hidden':'loggedOut',
		'children': [
			{'title':'LIST', 'path':'/list/Work_Orders', 'icon':'fa fa-minus', 'component':''},
			{'title':'NEW_RECORD', 'path':'/edit/Work_Orders', 'icon':'fa fa-minus', 'component':''},
		]
	},
}


export const defaultRoutes = [
	{'title':'DASHBOARD', 'path':'/', 'icon':'fa fa-dashboard', 'component':'Dashboard'},
	{'title':'LOGIN', 'path':'/login/', 'icon':'fa fa-user', 'component':'Login', 'template': 'Authentication', 'hidden':'loggedIn'},
	{'title':'LOGIN', 'path':'/login/:lang', 'icon':'fa fa-user', 'component':'Login', 'template': 'Authentication', 'hidden':'loggedIn'},
	{'title':'REGISTER', 'path':'/register', 'icon':'fa fa-user', 'component':'Register', 'template': 'Authentication', 'hidden':'loggedIn'},
	{'title':'FORGET_PASSWORD', 'path':'/forgotpassword', 'icon':'fa fa-user', 'component':'ForgotPassword', 'template': 'Authentication', 'hidden':'always'},
	{'title':'FEATURES', 'path':'/features', 'icon':'fa fa-boxes', 'component':'Features','hidden':'always'},
	{'title':'DYNAMIC', 'path':'/dynamic/:id', 'icon':'fa fa-star', 'component':'Dynamic','hidden': (tenantConfig.routes ? '' : 'always'), 'children':(tenantConfig.routes ? tenantConfig.routes : [])},
	{'title':'USEFULL_LINKS', 'path':'/dynamic/:id', 'icon':'fa fa-star', 'component':'Dynamic','hidden': (tenantConfig.customelink ? '' : 'always'), 'children':(tenantConfig.customelink ? tenantConfig.customelink : [])},
	{'title':'USER_SETTINGS', 'path':'/Profile', 'icon':'fa fa-boxes', 'component':'Profile','hidden':'loggedOut'},
	{'title':'LIST', 'path':'/list/:module', 'icon':'fa fa-boxes', 'component':'ListView','hidden':'always'},
	{'title':'CREATE', 'path':'/edit/:module/', 'icon':'fa fa-pencil', 'component':'EditView','hidden':'always'},
	{'title':'EDIT', 'path':'/edit/:module/:id', 'icon':'fa fa-pencil', 'component':'EditView','hidden':'always'},
	{'title':'DETAIL', 'path':'/detail/:module/:id', 'icon':'fa fa-minus', 'component':'DetailView','hidden':'always'},
	{'title':'SEARCH', 'path':'/search/:searchString', 'icon':'fa fa-search', 'component':'Search','hidden':'always'},
	{'title':'SUBPANEL', 'path':'/subpanel/:module/:id', 'icon':'fa fa-minus', 'component':'Subpanel','hidden':'always'},
	{'title':'LOG_OUT', 'path':'/logout', 'icon':'fa fa-sign-out-alt', 'component':'Logout', 'hidden':'loggedOut'},
	{'title':'Not Found', 'path':'*', 'icon':'fa fa-ban', 'component':'NotFound', 'hidden':'always'},
	{'title':'GATEWAY', 'path':'/gateway/:module/:id', 'component':'Gateway','hidden':'always'},
];

export const settings = {
	'sidebar': (window.innerWidth > 1200 ? 'expand' : 'collapse'),
	'routes': defaultRoutes,
	'strings': {
		'dropdown_container': 'vision-select-container',
		'dropdown_prefix': 'vision-select'
	},
	'disable_fields': [
		'id', 'date_entered', 'date_modified', 'created_by', 'modified_user_id', 'assigned_user_id',
		'number_as', 'as_sync_date',
		'amount_based_on', 'currency_id', 'total_amount','tax_amount', 'discount_amount',
		'converted', 'number', 'last_replier_name', 'last_replier_id', 'case_origin_c', 'actual_hours_to_complete_c', 'probability', 'day_remaining',
		'case_number', 'reference_number',
	],
	'hidden_fields': [
		'total_amount',
	],
	'FAQ': ['Cases'],
	'financial_modules': ['AOS_Quotes', 'AOS_Invoices', 'AOS_Contracts', 'AOS_Products', 'Work_Orders', 'Opportunities', 'Payments'],
	'dropdowns': {
		'themes': {
			'SG': language["THEMES"]["SG"],
			'Default': language["THEMES"]["DEFAULT"],
			'Dark': language["THEMES"]["DARK"],
		},
		'languages': {
			'fa_IR': language["LANGUAGES"]["FA"],
			'en_US': language["LANGUAGES"]["EN"],
		},
		'dates' : {
			'day' : language["DATE"]["DAY"],
			'week' : language["DATE"]["WEEK"],
			'month' : language["DATE"]["MONTH"],
			'quarter' : language["DATE"]["QUARTER"],
			'year' : language["DATE"]["YEAR"]
		}
	},
};